import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Row, Loading } from 'rp-react-table';
import DescendantsList from './DescendantsList';

class NicksRow extends PureComponent {
    shouldComponentUpdate(nextProps) {
        const { data, expanded } = this.props;
        if (data === nextProps.data && expanded === nextProps.expanded) {
            return false;
        }

        return true;
    }

    render() {
        const { rowData, columns, expanded, data } = this.props;

        return (
            <tbody className="hp-nicks__row">
                <Row
                    rowData={rowData}
                    columns={columns}
                />
                {expanded && (
                    <tr className="ui-table__row">
                        <td colSpan="8">
                            {data ? <DescendantsList data={data} /> : <Loading />}
                        </td>
                    </tr>
                )}
            </tbody>
        );
    }
}

NicksRow.propTypes = {
    rowData: PropTypes.shape({
        horseUid: PropTypes.number.isRequired,
        styleName: PropTypes.string.isRequired,
        runs: PropTypes.number.isRequired,
        wins: PropTypes.number.isRequired,
        winsPercent: PropTypes.number.isRequired,
        runners: PropTypes.number.isRequired,
        winners: PropTypes.number.isRequired,
        winnersPercent: PropTypes.number.isRequired,
        totalMoney: PropTypes.number.isRequired,
        winPrizeMoney: PropTypes.number.isRequired,
        descendants: PropTypes.bool.isRequired,
    }).isRequired,
    columns: PropTypes.arrayOf(PropTypes.shape({
        key: PropTypes.string.isRequired,
    })).isRequired,
    expanded: PropTypes.bool.isRequired,
    data: PropTypes.arrayOf(PropTypes.shape({
        horseUid: PropTypes.number.isRequired,
        styleName: PropTypes.string.isRequired,
    })),
};

export default NicksRow;




// WEBPACK FOOTER //
// ./src/js/horse/nicks/components/NickRow.jsx